import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.666 4.667a.667.667 0 0 0 1.334 0V4h4v.667a.667.667 0 0 0 1.333 0V4h2v1.333a.667.667 0 0 0 1.333 0V4c0-.736-.597-1.333-1.333-1.333h-2V2A.667.667 0 0 0 10 2v.667H6V2a.667.667 0 1 0-1.334 0v.667h-2c-.736 0-1.333.597-1.333 1.333v8.667c0 .736.597 1.333 1.333 1.333h2.667a.667.667 0 0 0 0-1.333H2.666V4h2z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.334 10.89a1.333 1.333 0 0 0 0 1.886l.775.775.452-.29a.24.24 0 0 1 .293.045.24.24 0 0 1 .046.293l-.291.452.78.782c.521.52 1.365.52 1.886 0l3.557-3.556a1.333 1.333 0 0 0 0-1.886l-.784-.785-.454.3a.24.24 0 0 1-.295-.045.24.24 0 0 1-.044-.295l.299-.454-.778-.778a1.333 1.333 0 0 0-1.885 0zm1.034 1.035-.092-.092 3.557-3.556.087.087a1.59 1.59 0 0 0 .436 1.44c.388.389.934.54 1.44.436l.094.094-3.558 3.556-.097-.098a1.59 1.59 0 0 0-.438-1.43 1.59 1.59 0 0 0-1.429-.437",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }